'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('@ali/prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _resource = require('@ali/resource');

var _resource2 = _interopRequireDefault(_resource);

var _get_locale = require('@ali/brokkoli/lib/utils/get_locale');

var _get_locale2 = _interopRequireDefault(_get_locale);

var _broccoliCmpImgframe = require('@ali/broccoli-cmp-imgframe');

var _broccoliCmpImgframe2 = _interopRequireDefault(_broccoliCmpImgframe);

require('./index.styl');

require('@ali/unit/css/mixin.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Index = function (_Component) {
  _inherits(Index, _Component);

  function Index(props) {
    _classCallCheck(this, Index);

    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));

    _this.state = {};
    _this.actStart = _this.actStart.bind(_this);
    return _this;
  }

  _createClass(Index, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setBtnStart();
    }

    // 校验是否一个正确的 url

  }, {
    key: 'isUrl',
    value: function isUrl(str) {
      if (!str) return false;
      var matcher = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
      return matcher.test(str);
    }
  }, {
    key: 'setBtnStart',
    value: function setBtnStart() {
      var startBtn = this.props.startBtn;

      if (this.isUrl(startBtn)) {
        this.loadBtnStart(startBtn);
      } else if (this.isUrl((0, _get_locale2.default)(startBtn))) {
        this.loadBtnStart((0, _get_locale2.default)(startBtn));
      }
    }
  }, {
    key: 'loadBtnStart',
    value: function loadBtnStart(bg) {
      var _this2 = this;

      _resource2.default.loadResource([bg], function () {
        var $img = _resource2.default.getResource(bg);
        _this2.setState({
          styleStartBtn: {
            width: $img.width / 1000 + 'rem',
            height: $img.height / 1000 + 'rem',
            backgroundImage: 'url(' + bg + ')'
          }
        });
      });
    }
  }, {
    key: 'renderBtnStart',
    value: function renderBtnStart() {
      var styleStartBtn = this.state.styleStartBtn;
      var _props = this.props,
          _props$leftStart = _props.leftStart,
          leftStart = _props$leftStart === undefined ? 0 : _props$leftStart,
          _props$bottomStart = _props.bottomStart,
          bottomStart = _props$bottomStart === undefined ? 0 : _props$bottomStart;

      var pfMatch = (window.location.search || '').match(/(?:&|\?|)pf=(.*?)(?:&|$)/);
      var isMini = (pfMatch || [])[1] in { 139: null, 140: null, 142: null };
      var bottom = isMini ? bottomStart + (this.props.offsetOnMinn == null ? 148 : this.props.offsetOnMinn) : bottomStart;
      return _react2.default.createElement('div', { className: 'start-btn', style: _extends({}, styleStartBtn, {
          left: leftStart / 1000 + 'rem',
          bottom: bottom / 1000 + 'rem'
        }), onClick: this.actStart });
    }
  }, {
    key: 'renderFrames',
    value: function renderFrames() {
      var _props2 = this.props,
          frames = _props2.frames,
          _props2$frames = _props2.frames,
          _props2$frames$left = _props2$frames.left,
          left = _props2$frames$left === undefined ? 0 : _props2$frames$left,
          _props2$frames$top = _props2$frames.top,
          top = _props2$frames$top === undefined ? 0 : _props2$frames$top;

      return _react2.default.createElement(
        'div',
        { className: 'frames', style: {
            left: left / 1000 + 'rem',
            top: top / 1000 + 'rem'
          } },
        _react2.default.createElement(_broccoliCmpImgframe2.default, frames)
      );
    }
  }, {
    key: 'actStart',
    value: function actStart() {
      var start = this.props.start;

      if (start) start();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          cls = _props3.cls,
          bg = _props3.bg,
          bgColor = _props3.bgColor,
          slogan = _props3.slogan;

      return _react2.default.createElement(
        'div',
        { className: 'broccoli-cmp-pageindex ' + cls, style: {
            backgroundImage: bg ? 'url(' + bg + ')' : 'none',
            backgroundColor: bgColor
          } },
        this.renderFrames(),
        _react2.default.createElement('div', { className: 'slogan', style: {
            backgroundImage: slogan !== (0, _get_locale2.default)(slogan) ? 'url(' + (0, _get_locale2.default)(slogan) + ')' : 'none'
          } }),
        this.props.children,
        this.renderBtnStart()
      );
    }
  }]);

  return Index;
}(_react.Component);

Index.propTypes = {
  /**
   * @title 背景色
   */
  bgColor: _propTypes2.default.string,
  /**
   * @title 背景图片
   */
  bg: _propTypes2.default.string,
  /**
   * @title 开始按钮左边距
   */
  leftStart: _propTypes2.default.number,
  /**
   * @title 开始按钮距离屏幕底部距离
   */
  bottomStart: _propTypes2.default.number,
  /**
   * @title 开始按钮切图链接(巴别塔定义的key)
   */
  startBtn: _propTypes2.default.string,
  /**
   * @title slogan切图链接(巴别塔定义的key)
   */
  slogan: _propTypes2.default.string,
  /**
   * @title 序列帧设置
   */
  frames: _propTypes2.default.shape({
    /**
     * @title 序列帧loading图
     */
    img: _propTypes2.default.string,
    /**
     * @title 以倍数增加减少动画周期时间
     */
    ratio: _propTypes2.default.number,
    /**
     * @title 帧数
     */
    num: _propTypes2.default.number,
    /**
     * @title 帧数组，帧标示最小从1开始以逗号隔开
     */
    frameArr: _propTypes2.default.string,
    /**
     * @title 宽度（非必填）
     */
    width: _propTypes2.default.number,
    /**
     * @title 高度（非必填）
     */
    height: _propTypes2.default.number,
    /**
     * @title 图片加载成功后延迟操作，毫秒（非必填）
     */
    timeHack: _propTypes2.default.number,
    /**
     * @title 左边距（非必填）
     */
    left: _propTypes2.default.number,
    /**
     * @title 上边距（非必填）
     */
    top: _propTypes2.default.number
  }),
  /**
   * @title 定义样式覆盖的class name(可选)
   */
  cls: _propTypes2.default.string
};
Index.defaultProps = {
  container: true,
  bgColor: '#ffffff',
  startBtn: 'homepage.startbtn',
  slogan: 'homepage.slogan',
  frames: {},
  cls: ''
};
exports.default = Index;